<template>
  <div class="contribute-info">
    <div class="header">
      <div class="left">
        <img class="icon" :src="icon" alt="" />
        <div class="name">
          {{ params.title }}.{{
            params[file_path]
              ? params[file_path].split(".")[
                  params[file_path].split(".").length - 1
                ]
              : ""
          }}
        </div>
      </div>
      <div class="again" @click="$emit('handleAgain')">重新上传</div>
    </div>
    <!-- <div class="item">
      <div class="label">*封面:</div>
      <div class="cover">
        <el-upload
          class="cover-upload"
          action="-"
          ref="upload"
          :show-file-list="false"
          :http-request="uploadImage"
        >
          <div class="cover-content">
            <div class="cover-img-box" v-if="params.cover">
              <img class="cover-img" :src="params.cover" />
              <div class="change-cover">更改封面</div>
            </div>
            <div class="cover-upload" v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="cover-tips">
              <span>支持jpg、jpeg、png等多种格式，单张图片最大支持20MB</span>
            </div>
          </div>
        </el-upload>
      </div>
    </div> -->
    <div class="item" v-if="showFileIcon">
      <div class="label">*文件:</div>
      <div class="file-icon">
        <div class="file-icon-content">
          <div class="file-icon-img-box">
            <img class="file-icon-img" :src="fileIcon" />
          </div>
          <div class="file-icon-tips">
            <span>支持pdf、word、压缩文件等多种格式，单个文件最大支持20MB</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="label">*标题:</div>
      <input class="title" v-model="params.title" />
    </div>
    <div class="item">
      <div class="label">*标签:</div>
      <div class="tags-box">
        <div class="tag" v-for="(tag, tag_index) in tagsList" :key="tag_index">
          <span>{{ tag }}</span>
          <img
            class="icon"
            src="@/assets/icon/del_white.png"
            @click="delTag(tag_index)"
          />
        </div>
        <input
          type="text"
          class="entry"
          placeholder="按回车键Enter创建标签"
          v-model="tagValue"
          v-show="tagsList.length != 20"
          @keydown.enter="addTag"
        />
        <div class="tips">还可以添加{{ 20 - tagsList.length }}个标签</div>
      </div>
    </div>
    <div class="item">
      <div class="label">简介:</div>
      <textarea
        class="desc"
        v-model="params.desc"
        placeholder="填写更全面的信息，让更多人看到你吧！"
      ></textarea>
    </div>
    <div class="item">
      <div class="label"></div>
      <div class="btn-box">
        <div class="btn confirm" @click="$emit('confirm')">立即投稿</div>
        <div class="btn cancel" @click="$emit('cancel')">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileIcon, getFileType } from "@/common/util";
import { uploadFile } from "@/common/service";
export default {
  name: "ContributeInfo",
  props: {
    // 参数信息
    params: {
      type: Object,
    },
    // 图标
    icon: {
      type: String,
    },
    // 文件路径字段
    file_path: {
      type: String,
    },
    // 显示文件类型
    showFileIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 标签列表
      tagsList: [],
      // 标签内容
      tagValue: "",
    };
  },
  computed: {
    fileType() {
      return getFileType(this.params[this.file_path] || "");
    },
    fileIcon() {
      return getFileIcon(`${this.fileType}_refer`);
    },
  },
  methods: {
    // 添加标签
    addTag() {
      if (!this.tagValue || this.tagsList.length == 20) return;
      this.tagsList.push(this.tagValue);
      this.params.label = this.tagsList.join(",");
      this.tagValue = "";
    },
    // 删除标签
    delTag(index) {
      this.tagsList.splice(index, 1);
      this.params.label = this.tagsList.join(",");
    },
    // 上传图片
    uploadImage(config) {
      uploadFile(config.file).then(({ data }) => {
        this.params.cover = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contribute-info {
  .header {
    width: calc(100% - 40px);
    height: 70px;
    background: #0054f7;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .left {
      display: flex;
      align-items: center;
      .icon {
        width: 26px;
        height: 23px;
      }
      .name {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        margin-left: 10px;
      }
    }
    .again {
      width: 80px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #ffffff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #0054f7;
      cursor: pointer;
    }
  }
  .item {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    .label {
      height: 50px;
      width: 80px;
      line-height: 50px;
      text-align: left;
      font-size: 18px;
      font-weight: 400;
      color: #222222;
    }
    .cover {
      height: 200px;
      width: calc(100% - 100px);
      margin-top: 14px;
      > .cover-upload {
        width: 100%;
        height: 100%;
      }
      .cover-content {
        width: 100%;
        height: 100%;
        display: flex;
        .cover-upload {
          width: 360px;
          height: 200px;
          border: 1px dashed #868686;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 40px;
        }
        .cover-upload:hover {
        }
        .cover-img-box {
          width: 360px;
          height: 200px;
          position: relative;
          .cover-img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
          .change-cover {
            width: 100%;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 0px 0px 8px 8px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }
        .cover-tips {
          height: 200px;
          width: 240px;
          font-size: 14px;
          font-weight: 400;
          color: #929292;
          text-align: left;
          margin-left: 15px;
          display: flex;
          align-items: flex-end;
          user-select: none;
        }
      }
    }
    .file-icon {
      height: 200px;
      width: calc(100% - 100px);
      margin-top: 14px;
      .file-icon-content {
        width: 100%;
        height: 100%;
        display: flex;
        .file-icon-img-box {
          width: 200pxpx;
          height: 200px;
          position: relative;
          .file-icon-img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
        .file-icon-tips {
          height: 200px;
          width: 240px;
          font-size: 14px;
          font-weight: 400;
          color: #929292;
          text-align: left;
          margin-left: 15px;
          display: flex;
          align-items: flex-end;
          user-select: none;
        }
      }
    }
    .title {
      width: calc(100% - 95px);
      height: 50px;
      border-radius: 6px;
      border: 1px solid #cccccc;
      padding: 0 15px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      outline: none;
    }
    .tags-box {
      width: calc(100% - 95px);
      min-height: 40px;
      border-radius: 6px;
      border: 1px solid #cccccc;
      padding: 5px 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: relative;
      .tag {
        display: flex;
        align-items: center;
        height: 35px;
        padding: 5px 15px;
        box-sizing: border-box;
        background: #0054f7;
        border-radius: 4px;
        margin: 3.5px 10px 3.5px 0;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
        .icon {
          width: 14px;
          height: 14px;
          margin-left: 5px;
        }
      }

      .entry {
        border: none;
        outline: none;
        height: 40px;
        width: 40%;
        min-width: 300px;
        max-width: 600px;
        font-size: 16px;
        font-weight: 400;
        color: #222222;
      }
      .entry::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: rgba(34, 34, 34, 0.3);
      }
      .tips {
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #222222;
        position: absolute;
        line-height: 40px;
        padding: 1px 0;
        right: 15px;
        bottom: 5px;
      }
    }
    .desc {
      width: calc(100% - 95px);
      height: 200px;
      border-radius: 6px;
      border: 1px solid #cccccc;
      padding: 15px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      outline: none;
      resize: none;
    }
    .desc::placeholder {
      font-size: 16px;
      font-weight: 400;
      color: #c1c1c1;
    }
    .btn-box {
      display: flex;
      .btn {
        width: 120px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        border-radius: 6px;
        font-size: 17px;
        font-weight: 400;
        border: 1px solid transparent;
        cursor: pointer;
      }
      .confirm {
        background: #0054f7;
        color: #ffffff;
      }
      .cancel {
        border: 1px solid #979797;
        color: #131415;
        margin-left: 30px;
      }
    }
  }
}
</style>
